import React, { useEffect, useRef, useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";
import { CalendarIcon } from "./icons";

const parseDateStr = (str) => {
  if (!str) return undefined;
  const [y, m, d] = str.split("-").map(Number);
  return new Date(y, m - 1, d);
};

const formatDateStr = (date) => {
  if (!date) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

const formatDisplay = (start, end) => {
  if (!start) return "Select date range";
  if (!end) return `${start} – ...`;
  return `${start} – ${end}`;
};

const DateRangeField = ({ startDate, endDate, onChange }) => {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia && window.matchMedia("(max-width: 640px)").matches
  );
  const containerRef = useRef(null);

  useEffect(() => {
    const mql = window.matchMedia("(max-width: 640px)");
    const handleChange = (e) => setIsMobile(e.matches);
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const selectedRange = { from: parseDateStr(startDate), to: parseDateStr(endDate) };

  const handleSelect = (range) => {
    onChange(formatDateStr(range?.from), formatDateStr(range?.to));
  };

  return (
    <div className="field date-range-field" ref={containerRef}>
      <label>Date range</label>
      <button
        type="button"
        className="date-range-trigger"
        onClick={() => setOpen((o) => !o)}
      >
        <CalendarIcon />
        <span>{formatDisplay(startDate, endDate)}</span>
      </button>
      {open && (
        <div className="date-range-popover">
          <DayPicker
            mode="range"
            selected={selectedRange}
            onSelect={handleSelect}
            numberOfMonths={isMobile ? 1 : 2}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangeField;
